export default {
  "panels": [{
    "index": 0,
    "height": 60,
    "width": 80,
    "paperHeader": -15,
    "paperFooter": 170.07874015748033,
    "printElements": [{
      "options": {
        "left": 28.5,
        "top": 12,
        "height": 17,
        "width": 120,
        "testData": "单据表头",
        "fontSize": 16.5,
        "fontWeight": "700",
        "textAlign": "center",
        "hideTitle": true,
        "title": "单据表头"
      }, "printElementType": {"title": "单据表头", "type": "text"}
    }, {
      "options": {
        "left": 28.5,
        "top": 34.5,
        "height": 120,
        "width": 120,
        "testData": "XS888888888",
        "fontSize": 12,
        "lineHeight": 18,
        "fontWeight": "700",
        "textAlign": "left",
        "textType": "qrcode",
        "title": "二维码"
      }, "printElementType": {"title": "二维码", "type": "text"}
    }, {
      "options": {
        "left": 157.5,
        "top": 15,
        "height": 9.75,
        "width": 57,
        "title": "第",
        "field": "count",
        "testData": "1"
      }, "printElementType": {"title": "文本", "type": "text"}
    }],
    "paperNumberLeft": 196,
    "paperNumberTop": 148,
    "paperNumberDisabled": true
  }]
}
